<template>
  <div class="premium-feature-card" data-testid="premium-feature-card">
    <!-- Premium Badge -->
    <div class="premium-badge">
      <img :src="upgradeCrown" alt="" class="crown-icon" />
      <span class="badge-text">PREMIUM FEATURE</span>
    </div>

    <!-- Content -->
    <div class="content">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ description }}</p>
    </div>

    <!-- Upgrade Button -->
    <button class="upgrade-button" @click="handleUpgrade" data-testid="premium-feature-upgrade">
      <span class="button-text">Upgrade</span>
    </button>
  </div>
</template>

<script lang="ts" setup>
import upgradeCrown from './upgrade-crown.svg';

interface Props {
  title: string;
  description: string;
  onUpgrade?: () => void;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  upgrade: [];
}>();

const handleUpgrade = () => {
  if (props.onUpgrade) {
    props.onUpgrade();
  }
  emit('upgrade');
};
</script>

<style scoped>
.premium-feature-card {
  @apply w-full rounded-[10px] border border-zinc-200 dark:border-zinc-700 flex flex-col items-start gap-4 p-3.5;
}

/* Premium Badge */
.premium-badge {
  @apply rounded-[28px] bg-zinc-50 dark:bg-zinc-800 border border-zinc-100 dark:border-zinc-700 flex items-center py-0 px-2 gap-[6.6px];
}

.crown-icon {
  @apply h-[22.7px] w-[22.7px] object-contain;
}

.badge-text {
  @apply text-[11.36px] font-bold leading-[32.2px] tracking-tight;
  background: linear-gradient(86.52deg, #eb6c57, #e4983e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Content */
.content {
  @apply self-stretch flex flex-col items-start gap-1;
}

.title {
  @apply self-stretch text-sm font-bold text-zinc-900 dark:text-zinc-100;
}

.description {
  @apply self-stretch text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed;
}

/* Upgrade Button */
.upgrade-button {
  @apply h-9 rounded-[10px] border border-[#D97644] dark:border-[#D97644]/70 overflow-hidden flex items-center justify-center py-0.5 px-3 transition-all active:scale-95 cursor-pointer;
  background: linear-gradient(86.52deg, #e4983e, #eb6c57);
}

.upgrade-button:hover {
  @apply brightness-110;
}

.button-text {
  @apply text-xs font-bold tracking-tight text-white leading-none;
}
</style>
